webpackJsonp([2],{

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.init = init;
	
	var _promise = __webpack_require__(30);
	
	var _born = __webpack_require__(10);
	
	var _module = __webpack_require__(40);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _offertimer = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bornModules = __webpack_require__(3).default;
	var ajax = __webpack_require__(42);
	var util = __webpack_require__(15);
	var checkinstore = __webpack_require__(44);
	var pageNumber = 1;
	var progress = __webpack_require__(43);
	var $main = $('#main');
	var lazyPictureLoad = __webpack_require__(48);
	
	function init() {
		var pID = document.querySelector('#pid') ? document.querySelector('#pid').value : 'product-set',
		    thumbContainer = document.querySelector('.pdp__gallery__sm'),
		    thumbCount;
		checkinstore.initstore();
		if (thumbContainer) {
			$('.pdp__gallery__lg').on('galleryZoomStart', function () {
				lazyLoadPDPVideo('.zoom-row');
				var isFullScreen = false;
				$('.zoom-row video').on('fullscreenchange mozfullscreenchange webkitfullscreenchange', function () {
					isFullScreen && $('.zoom__gallery').slick('refresh');
					isFullScreen = !isFullScreen;
				});
				$(this).off('galleryZoomStart');
			});
			var thumbCount = thumbContainer.getAttribute('data-thumbcount'),
			    thumbCountCap = {
				tablet: parseInt(thumbCount > 4 ? 4 : thumbCount),
				desktop: parseInt(thumbCount > 8 ? 8 : thumbCount)
			},
			    zoom = new _module2.default({
				modalID: pID,
				gallery: '.pdp__gallery__lg',
				items: '.pdp__gallery__media',
				useTrigger: true,
				sliderSyncing: true,
				thumbsSlick: {
					slidesToShow: thumbCountCap.desktop,
					slidesToScroll: thumbCountCap.desktop,
					vertical: true,
					verticalSwiping: true,
					responsive: [{
						breakpoint: 1025,
						settings: {
							slidesToShow: thumbCountCap.tablet,
							slidesToScroll: thumbCountCap.tablet
						}
					}]
				},
				gallerySlick: {
					fade: true,
					waitForAnimate: false,
					adaptiveHeight: true,
					responsive: [{
						breakpoint: 767,
						settings: {
							arrows: true,
							dots: true,
							swipe: true
						}
					}]
				}
			});
		}
		updateRatingPercentageWidth();
		handleReviewSort();
		handleMoreReviews();
		handleShowLessReviews();
		scrollToReview();
		reviewSortAction();
		bookstoreappointment();
		handlePDPGAEvents();
		$('#add-to-cart').attr('disabled', false);
	
		// PHNX-1038 Changes
		window.addEventListener('load', function () {
			var countrySelectorDropDown = $('#countrySelectorList');
			if (countrySelectorDropDown.length > 0 && countrySelectorDropDown.find('[selected="selected"]').length > 0) {
				countrySelectorDropDown.val($('#countrySelectorList [selected="selected"]').val()).selectric('refresh');
			}
		});
		$('.description-spec-toggler').off('click.hltDescToggle').on('click.hltDescToggle', function () {
			$('.pdp__info.secondary__info').toggleClass('active');
			var toggleElement = '.pdp__info.secondary__info .pdp__info__wrapper .pdp__info__section';
			$(toggleElement + '.toggle--active').length === 0 && $(toggleElement + ' .toggle__link').first().click();
			$('html, body').toggleClass('no-scroll');
		});
		lazyLoadPDPVideo();
		dockImgAtTop();
	
		thumbNextBtnPlacement();
		slickOnResizeHandler();
	
		$(document).ready(function () {
			hideEmptySection();
		});
		(0, _offertimer.pdpOfferTimer)();
		setTimeout(function () {
			shouldKeepSwatchesOpen();
		}, 500);
		quantityButtonCheck();
		videoPlayClickListener();
		lazyPictureLoad.init();
		showHidemobileGalleryPopup();
		addEllipsisToBreadcrumbMob();
	}
	
	function addEllipsisToBreadcrumbMob() {
		var timer = void 0;
	
		$(window).on('load resize modal-open', function () {
			debounce(function () {
				if (window.innerWidth > 767) return;
				var $breadcrumbs = $('#breadcrumbs, .coming-soon__dialog #breadcrumbs, .back-in-stock__dialog #breadcrumbs');
				var haveOverflow = $breadcrumbs.length > 0 && isOverflown($breadcrumbs.get(0));
				haveOverflow ? $breadcrumbs.addClass('show-ellipsis') : $breadcrumbs.removeClass('show-ellipsis');
			}, 200, timer);
		});
	}
	
	// To set the top offset of next button in thumbnails according to height of the thumbnail container
	function thumbNextBtnPlacement() {
		var parseMutations = function parseMutations() {
			$('#thumbnails .slick-next').css('top', $('#thumbnails .slick-list').height() - 32 + 'px');
		};
		var observer = new MutationObserver(parseMutations);
		var doObserve = function doObserve() {
			parseMutations();
			observer.observe($('#thumbnails .slick-list').get(0), {
				attributeFilter: ["style"]
			});
		};
		if ($('#thumbnails .slick-list').length > 0) {
			doObserve();
		} else {
			var interval = setInterval(function () {
				if ($('#thumbnails .slick-list').length > 0) {
					doObserve();
					clearInterval(interval);
				}
			}, 200);
		}
	}
	
	// refresh slick on resize and adjust next button placement
	function slickOnResizeHandler() {
		var rTime = void 0,
		    timeout = false,
		    delta = 200;
		$(window).on('resize', function () {
			if (window.innerWidth < 768) return;
			rTime = new Date();
			if (!timeout) {
				timeout = true;
				setTimeout(resizeEnd, delta);
			}
		});
	
		var resizeEnd = function resizeEnd() {
			if (new Date() - rTime < delta) {
				setTimeout(resizeEnd, delta);
			} else {
				timeout = false;
				$('#thumbnails').slick('refresh');
				thumbNextBtnPlacement();
			}
		};
	}
	
	function bookstoreappointment() {
		if ($(".appointment-cta").length > 0) {
			$(document).on('click', '.appointment-cta', function () {
				e.preventDefault();
				var brandNameEl = $('input[name="produc-brand-name"]');
				var url = $(this).attr('href');
				if (brandNameEl.length <= 0) {
					window.location = url;
					return;
				}
				var brandName = brandNameEl.val();
				if (brandName) {
					brandName = brandName.trim();
					url += url.indexOf("?") === -1 ? "?" : "&";
					window.location = url + "name=" + encodeURIComponent(brandName);
				} else {
					window.location = url;
				}
			});
		}
	}
	
	function reviewSortAction() {
		var $toggledElements = $('.review__sorts,.review-sort-by-toggle');
		var propagationHandler = function propagationHandler(e) {
			e.stopImmediatePropagation();
			e.stopPropagation();
			e.preventDefault();
			if (!$toggledElements.hasClass('toggle--active')) {
				$('#main').off('click', '.review-sort-by-toggle', function (e) {
					return e.stopPropagation();
				});
				$(window).off('click', propagationHandler);
				$('body').removeClass('cancel-scroll');
			}
		};
		$('.review__sorts').on('click', function (e) {
			e.stopPropagation();
			var width = $(window).width();
			if (width <= 767) {
				$('body').addClass('cancel-scroll');
				if ($(e.currentTarget).hasClass('toggle--active')) {
					if (typeof zE !== 'undefined' && !!zE) {
						zE(function () {
							zE.hide();
						});
					}
				}
			}
			$(window).on('click', propagationHandler);
		});
	}
	function hideSortOption() {
		var $toggleEle = $(".review-sort-by-toggle,.review-sort-by-toggle .toggle__content,.review-sort-by-toggle .toggle__link");
		if ($(".review-sort-by-toggle").hasClass('toggle--active')) {
			$toggleEle.removeClass('toggle--active');
			$('body').removeClass('cancel-scroll');
		}
	}
	function handleMoreReviews() {
		$('#more-reviews').on('click', function () {
			progress.show($('.reviews-listing'));
			var url = $('.review__rating--sortby a.review-sort-selected').attr('href');
			var existingReviewsCount = $('.review-entry-wrapper').length;
			url = util.appendParamsToUrl(url, {
				'existingReviewsCount': existingReviewsCount
			});
			$.ajax({
				type: 'GET',
				url: url,
				success: function success(response) {
					$('.reviews-listing').append(response);
					updateRatingPercentageWidth();
					hideOrShowButton();
					progress.hide();
				}
			});
		});
	
		//avoid review sort menu closing, if clicked inside the menu
		$main.on('click', '.review-sort-by-toggle', function (e) {
			e.stopPropagation();
		});
		//Hide the sort menu if visible
		$(window).click(function (e) {
			e.stopPropagation();
			var $toggledElements = $('.review-sort-by-toggle');
			if ($toggledElements.hasClass('toggle--active')) {
				$toggledElements.removeClass('toggle--active');
			}
		});
	}
	
	function handleShowLessReviews() {
		$('#show-less-reviews').on('click', function () {
			progress.show($('.reviews-listing'));
			var url = $('.review__rating--sortby a.review-sort-selected').attr('href');
			$.ajax({
				type: 'GET',
				url: url,
				success: function success(response) {
					$('.review-details-wrapper').remove();
					$('.reviews-listing').append(response);
					updateRatingPercentageWidth();
					hideOrShowButton();
					$('html, body').animate({
						scrollTop: $(".pdp-reviews-wrapper").offset().top - 80
					}, 2000);
					progress.hide();
				}
			});
		});
	}
	
	function handleReviewSort() {
		$('.review__rating--sortby a').on('click', function (e) {
			e.preventDefault();
			progress.show($('.reviews-listing'));
			$('.review__rating--sortby a.review-sort-selected').removeClass('icon--tick review-sort-selected');
			$(this).addClass('icon--tick review-sort-selected');
			ajax.load({
				url: $(this).attr('href'),
				target: $('.reviews-listing'),
				callback: function callback(data) {
					updateRatingPercentageWidth();
					hideOrShowButton();
					hideSortOption();
					progress.hide();
				}
			});
		});
	}
	
	function updateRatingPercentageWidth() {
		$('.ratingstart').each(function () {
			var ratingPercentage = getRatingPercentage($(this).data('score'));
			$(this).find('.stars-inner').width(ratingPercentage);
		});
	}
	
	function getRatingPercentage(rating) {
		var ratingTotal = 5;
		var ratingPercentage = rating / ratingTotal * 100;
		ratingPercentage = ratingPercentage + '%';
		return ratingPercentage;
	}
	
	function hideOrShowButton() {
		var existingReviewsCount = $('.review-entry-wrapper').length;
		var totalReviewsCount = $('.reviews-listing').data('totalreview');
		// Reviews per page 5
		if (totalReviewsCount > 5) {
			if (existingReviewsCount < totalReviewsCount) {
				$('#more-reviews').show();
				$('#show-less-reviews').hide();
			} else if (existingReviewsCount == totalReviewsCount) {
				$('#more-reviews').hide();
				$('#show-less-reviews').show();
			}
		}
	}
	
	function scrollToReview() {
		$("#product-avg-rating").on('click', function () {
			setTimeout(function () {
				$([document.documentElement, document.body]).animate({
					scrollTop: $(".pdp-reviews-wrapper").offset().top - 100
				}, 1000);
			}, 500);
		});
	}
	
	function lazyLoadPDPVideo() {
		var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.pdp__gallery';
	
		var video = $(container + ' video');
		var videoElem = video.get(0);
		var sources = video.find('source');
		var hasShowSimilar = $(container + ' .pdp__gallery__show-similar').length > 0;
	
		video.off('click.controls').on('click.controls', function (e) {
			if (videoElem.paused) {
				videoElem.play();
				return;
			}
			videoElem.pause();
		});
	
		var setSources = function setSources(resolve) {
			var _sources = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : sources;
	
			_sources.each(function (index) {
				$(this).attr('src', $(this).data('vdosrc'));
				if (index + 1 == _sources.length) {
					video.addClass('src-loaded');
					resolve();
				}
			});
		};
	
		var loadVideo = function loadVideo() {
			var _videoElem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : videoElem;
	
			var shouldPlay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
			try {
				_videoElem.pause();
				_videoElem.load();
				shouldPlay && _videoElem.addEventListener('loadeddata', function () {
					_videoElem.play();
				}, false);
			} catch (err) {}
		};
	
		// lazy load on slide change
		function callback(mutationList, observer) {
			mutationList.forEach(function (mutation) {
				if (!mutation.type === 'attributes' || !mutation.attributeName === 'class') return;
	
				if (mutation.target.classList.contains('slick-active')) {
					hasShowSimilar && $('.pdp__gallery__show-similar').hide();
	
					if (!video.hasClass('src-loaded')) {
						new Promise(function (resolve, reject) {
							setSources(resolve);
						}).then(function () {
							loadVideo();
						});
					}
				} else {
					hasShowSimilar && $('.pdp__gallery__show-similar').show();
				}
			});
		}
		var observer = new MutationObserver(callback);
		video.length && observer.observe(video.parent(container + ' .video--playwrap').get(0), { attributes: true });
	}
	
	function isOverflown(element) {
		return element && (element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth);
	}
	
	function debounce(callback, delay, timer) {
		clearTimeout(timer);
		timer = setTimeout(callback, delay);
	}
	
	function dockImgAtTop() {
		// Remove the existing scroll listener if module is re initialized (In case of variant selection for product with variants)
		$(window).off('scroll.pdpScrollEvent');
	
		var $imageContainer = $('.product-image-container'),
		    $imageRow = $('#pdp-img-row'),
		    $breadcrumbs = $('#breadcrumbs, .coming-soon__dialog #breadcrumbs, .back-in-stock__dialog #breadcrumbs'),
		    $pdpRightSection = $('.pdp__right-section');
		var isBreadCrumbOverflown = $breadcrumbs.length > 0 && isOverflown($breadcrumbs.get(0)),
		    headerHeight = Math.round($('.header__main').height()),
		    calcedHeaderHeight = (0, _born.shouldEnableSticky)() ? headerHeight : 0;
	
		var rightSectHeight = $pdpRightSection.height();
	
		var toggleOverflow = function toggleOverflow() {
			if ($breadcrumbs.length === 0 || window.innerWidth < 768) return;
			if ($(window).scrollTop() >= 60) {
				$breadcrumbs.addClass('show-ellipsis');
			} else {
				$breadcrumbs.removeClass('show-ellipsis');
			}
		};
	
		if (isBreadCrumbOverflown) {
			$(window).on('scroll.pdpScrollEvent', toggleOverflow);
			toggleOverflow();
		}
	
		var dockDecision = function dockDecision(height) {
			var windowHeight = window.innerHeight;
			$imageRow.css('top', '');
			if (height < windowHeight - calcedHeaderHeight) $imageRow.css('top', calcedHeaderHeight + 5 + 'px');else {
				var topVal = Math.round(calcedHeaderHeight - Math.abs(height - (windowHeight - calcedHeaderHeight))) - 82 + 'px';
				$imageRow.css('top', topVal);
			}
		};
	
		var timer = void 0;
		$(window).on('resize', function () {
			if (window.innerWidth > 767) {
				headerHeight = Math.round($('.header__main').height());
				calcedHeaderHeight = (0, _born.shouldEnableSticky)() ? headerHeight : 0;
				debounce(function () {
					$(window).off('scroll.pdpScrollEvent');
					$breadcrumbs.removeClass('show-ellipsis');
					isBreadCrumbOverflown = $breadcrumbs.length > 0 && isOverflown($breadcrumbs.get(0));
					if (isBreadCrumbOverflown) {
						$(window).on('scroll.pdpScrollEvent', toggleOverflow);
						toggleOverflow();
					}
				}, 200, timer);
				dockDecision($imageContainer.height());
			} else $imageRow.css('top', '');
		});
	
		new ResizeObserver(function (entries) {
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;
	
			try {
				for (var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var entry = _step.value;
	
					var newHeight = entry.contentRect.height;
					dockDecision(newHeight);
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}
		}).observe($imageContainer.get(0));
	
		//to maintain scroll position
		new ResizeObserver(function (entries) {
			var _iteratorNormalCompletion2 = true;
			var _didIteratorError2 = false;
			var _iteratorError2 = undefined;
	
			try {
				for (var _iterator2 = entries[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
					var entry = _step2.value;
	
					var newHeight = entry.contentRect.height;
					if (newHeight < rightSectHeight && window.lastScrollPos) {
						var curScrollPos = $(window).scrollTop();
						window.lastScrollPos > curScrollPos && $(window).scrollTop(window.lastScrollPos - (rightSectHeight - newHeight));
					}
					window.lastScrollPos = null;
					rightSectHeight = newHeight;
				}
			} catch (err) {
				_didIteratorError2 = true;
				_iteratorError2 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion2 && _iterator2.return) {
						_iterator2.return();
					}
				} finally {
					if (_didIteratorError2) {
						throw _iteratorError2;
					}
				}
			}
		}).observe($pdpRightSection.get(0));
	
		window.innerWidth > 767 && dockDecision($imageContainer.height());
	}
	
	function hideEmptySection() {
		var sections = $('.pdp__info__section .pdp__info__content');
		var setFirstContent = false;
		sections.each(function (i, e) {
			var details = $(e).html();
			details = details.replace(/(<!--.*?-->)|(<!--[\S\s]+?-->)|(<!--[\S\s]*?$)/g, "");
			var el = $(e).closest('.pdp__info__section');
			if (!$.trim(details)) {
				if (el.length > 0) {
					el.addClass('hidden');
				}
			} else if (!setFirstContent) {
				el.addClass('first-content');
				setFirstContent = true;
			}
		});
	}
	
	function handlePDPGAEvents() {
		var user = dataLayer.find(function (o) {
			return o.user != null;
		}).user;
		var product = dataLayer.find(function (o) {
			return o.product != null;
		}).product;
		$('.sharing__trigger').on('click', function () {
			dataLayer.push({
				"event": 'custom_event',
				"eventCategory": 'PDP',
				"eventAction": 'pdp_share_click',
				"eventLabel": 'pdp share click',
				"productName": product.name,
				"country": window.GlobalAttributes.COUNTRY,
				"language": window.GlobalAttributes.LANGUAGE,
				"screenName": 'PDP',
				"userType": user.user_id != '' ? 'logged-in' : 'logged-out',
				"userId": user.user_id != '' ? user.user_id : ''
			});
		});
	
		$('.sharing__item').on('click', function () {
			dataLayer.push({
				"event": 'custom_event',
				"eventCategory": 'PDP',
				"eventAction": 'pdp_social_share',
				"eventLabel": $(this).data('share'),
				"productName": product.name,
				"country": window.GlobalAttributes.COUNTRY,
				"language": window.GlobalAttributes.LANGUAGE,
				"screenName": 'PDP',
				"userType": user.user_id != '' ? 'logged-in' : 'logged-out',
				"userId": user.user_id != '' ? user.user_id : ''
			});
		});
		$('body').on('click', '.js-size-guide-btn', function () {
			dataLayer.push({
				"event": 'custom_event',
				"eventCategory": 'PDP',
				"eventAction": 'pdp_size_guide',
				"eventLabel": 'pdp size guide click',
				"productName": product.name,
				"country": window.GlobalAttributes.COUNTRY,
				"language": window.GlobalAttributes.LANGUAGE,
				"screenName": 'PDP',
				"userType": user.user_id != '' ? 'logged-in' : 'logged-out',
				"userId": user.user_id != '' ? user.user_id : ''
			});
		});
	
		$('body').on('click', '.store-dirlink', function () {
			var storeName = $(this).parent().find('.store-name').text();
			dataLayer.push({
				'event': 'custom_event',
				'eventCategory': 'PDP',
				'eventAction': 'in_store_availability_get_direction',
				'eventLabel': 'check in store availability get direction - ' + storeName, //Store Name i..e Dubai Hills Mall
				"productName": product.name,
				"country": window.GlobalAttributes.COUNTRY,
				"language": window.GlobalAttributes.LANGUAGE,
				"screenName": 'PDP',
				"userType": user.user_id != '' ? 'logged-in' : 'logged-out',
				"userId": user.user_id != '' ? user.user_id : ''
			});
		});
	}
	
	// function to keep swatches open when a variant from the hidden swatches are accessed directly
	function shouldKeepSwatchesOpen() {
		var $swatchContainer = $('#swatch-variation');
		if ($swatchContainer.length == 0) return;
		var index = -1;
		index = $swatchContainer.find('.swatches__item').index($('.swatches__item.selected'));
		var containerWidth = $swatchContainer.innerWidth(),
		    elementWidth = $('.swatches__item').innerWidth() + parseInt($('.swatches__item').css('margin-right'));
		var visibleItems = parseInt(containerWidth / elementWidth) * 2;
		if (index + 1 > visibleItems) {
			$('#show-more-link:not(.toggle--active)').trigger('click');
		}
	}
	function quantityButtonCheck() {
		$('input.qty-input__ctrl').on('change', function (event) {
			var maxValue = void 0;
			var maxQty = $(event.target).data('max-qty');
			if (maxQty > 0) {
				maxValue = maxQty;
			} else {
				maxValue = $(event.target).data('available');
			}
			var currVal = event.target.value;
			if (currVal < maxValue) {
				$('button.qty-input__ctrl.plus').removeAttr('disabled');
			} else {
				$('button.qty-input__ctrl.plus').attr('disabled', 'true');
			}
			if (currVal <= maxValue) {
				$('button.add-to-cart').removeAttr('disabled');
			} else {
				$('button.add-to-cart').attr('disabled', 'true');
			}
		});
	}
	function videoPlayClickListener() {
		$('.pdp__product-gallery--video-tile.video-tile').on('click.pointerEventsListener', function () {
			$(this).find('video').removeClass('no-pointer-events');
			$(this).off('click.pointerEventsListener');
		});
		$('.pdp__product-gallery--popup video').on('play', function () {
			$(this).attr('controls', '');
			$(this).parent().removeClass('video-poster');
		});
	}
	
	function showHidemobileGalleryPopup() {
		$('.pdp__product-gallery--items picture').on('click', function () {
			var gotoIndex = $('.pdp__product-gallery--items picture').index(this);
			$('.pdp__product-gallery--popup').removeClass('hidden').find('.slick-slider').slick('refresh').slick('slickGoTo', gotoIndex);
			if (window.innerWidth < 768) {
				$('body').addClass('cancel-scroll');
			}
		});
		$('.pdp__product-gallery--popup').on('click', function () {
			$('.pdp__product-gallery--popup').addClass('hidden');
			var $video = $('.pdp__product-gallery--popup video').get(0);
			$video && $video.pause();
			if (window.innerWidth < 768) {
				$('body').removeClass('cancel-scroll');
			}
		});
		$('.pdp__product-gallery--popup .slick-slider').on('click', function (e) {
			e.stopPropagation();
		});
		$('.pdp__product-gallery--popup .slick-slider').on('beforeChange', function () {
			var $video = $('.pdp__product-gallery--popup video').get(0);
			$video && $video.pause();
		});
	}

/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _imagesloaded = __webpack_require__(13);
	
	var _imagesloaded2 = _interopRequireDefault(_imagesloaded);
	
	var _module = __webpack_require__(20);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _module3 = __webpack_require__(11);
	
	var _module4 = _interopRequireDefault(_module3);
	
	var _born = __webpack_require__(3);
	
	var _born2 = _interopRequireDefault(_born);
	
	var _born3 = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * gallery: String | Node. Selector or element to use as gallery container.
	 */
	
	var GalleryZoom = function () {
		function GalleryZoom(options) {
			_classCallCheck(this, GalleryZoom);
	
			this.options = options || {};
	
			this.options.type = this.options.type || 'slick';
			this.options.modalclass = this.options.modalclass || 'modal--pdp-zoom';
			this.options.modalID = this.options.modalID || 'overlay--pdp-zoom';
	
			if (this.options.type === 'slick') {
				this._$sourceGallery = $(this.options.gallery);
				this._itemList = this._$sourceGallery[0].querySelectorAll(this.options.items);
				this.setHandlers();
			}
		}
	
		_createClass(GalleryZoom, [{
			key: 'setHandlers',
			value: function setHandlers() {
				//Needs to be attached to the container, and not specific items if its a carousel because otherwise it screws with Slick's swiping mechanism
				this._$sourceGallery.off('.openZoom').on('click.openZoom', this.setupZoomedSlider.bind(this)).on('click.openZoom', function (e) {
					var target = $(e.target);
					!target.is('video') && !target.hasClass('video--playwrap') && $(this).trigger('galleryZoomStart');
				});
			}
		}, {
			key: 'setupZoomedSlider',
			value: function setupZoomedSlider(e) {
				if (!this.options.useTrigger || this.options.useTrigger && e.target.hasAttribute('data-zoom-trigger')) {
					var linkedModal = _module2.default.exists(this.options.modalID),
					    targetIndex = [].indexOf.call(this._itemList, e.target);
	
					//Save the clicked element's index to use it when sliderSyncing is turned off.
					this.triggerTargetIndex = targetIndex !== -1 ? targetIndex : 0;
	
					if (!linkedModal) {
						this.renderModal(this.createSliders());
					} else {
						_module2.default.openModal(linkedModal);
					}
				}
			}
		}, {
			key: 'createSliders',
			value: function createSliders() {
				var _this = this;
	
				var zContainer = this.createLayout(),
				    zGallerySettings = JSON.stringify(this.options.gallerySlick || ''),
				    zThumbsSettings = JSON.stringify(this.options.thumbsSlick || '');
	
				this._zGalleryClass = 'zoom__gallery';
				this._zThumbsClass = 'zoom__thumbnails';
	
				var zThumbsSlider = (0, _born3.createElWithAttrs)(zContainer.thumbsColumn, { 'class': this._zThumbsClass + ' slick--visible', 'data-slick': zThumbsSettings }),
				    zGallerySlider = (0, _born3.createElWithAttrs)(zContainer.galleryColumn, { 'class': this._zGalleryClass + ' slick--visible slick--preloaded slick--wide-arrows slick--hover-arrows', 'data-slick': zGallerySettings, 'data-slick-sync': '#modal-' + this.options.modalID + ' .' + this._zThumbsClass });
	
				[].forEach.call(this._itemList, function (item) {
					zThumbsSlider.appendChild(_this.createSliderItem(item));
					zGallerySlider.appendChild(_this.createSliderItem(item, true));
				});
	
				return zContainer.wrapper;
			}
		}, {
			key: 'createLayout',
			value: function createLayout() {
				var wrapper = (0, _born3.createElWithAttrs)(false, { 'class': 'zoom-row max-width--site gutter-padding row row-sm--fluid' });
	
				if (this.options.type === 'slick') {
					return {
						wrapper: wrapper,
						thumbsColumn: (0, _born3.createElWithAttrs)(wrapper, { 'class': 'col-lg-1 col-md-2 col-sm--fluid display--small-up' }),
						galleryColumn: (0, _born3.createElWithAttrs)(wrapper, { 'class': 'col-md-8 col-xs-12 col-sm--fluid' })
					};
				}
	
				return wrapper;
			}
		}, {
			key: 'createSliderItem',
			value: function createSliderItem(item, isMainItem) {
				var videoSettings = item.getAttribute('data-video'),
				    zoomItem = document.createElement('div');
	
				if (videoSettings && isMainItem) {
					if (item.nodeName === 'VIDEO') {
						var videoEl = (0, _born3.createElWithAttrs)(zoomItem, { 'data-video': videoSettings, 'poster': item.getAttribute('poster'), 'loop': item.getAttribute('loop') !== 'false' ? true : false, 'muted': item.hasAttribute('muted') !== 'false' ? true : false, 'controls': true, 'controlslist': 'nodownload' }, 'video');
	
						[].forEach.call(item.querySelectorAll('source'), function (source) {
							videoEl.appendChild(source.cloneNode());
						});
	
						if (videoSettings) {
							zoomItem.classList.add('video--playwrap', 'video--playwrap--thumb');
						}
					} else {
						(0, _born3.createElWithAttrs)(zoomItem, { 'data-video': videoSettings, 'class': item.video.options.youtubeID ? 'video--wide-format' : '' });
					}
				} else {
					var source = void 0;
	
					if (isMainItem) {
						source = item.getAttribute('data-high-res');
					} else if (videoSettings) {
						zoomItem.classList.add('video--playwrap', 'video--playwrap--thumb');
						source = item.getAttribute('poster');
					} else {
						source = item.src ? item.src : item.getAttribute('data-lazy');
					}
	
					(0, _born3.createElWithAttrs)(zoomItem, { 'src': source }, 'img');
				}
	
				return zoomItem;
			}
		}, {
			key: 'goToSlide',
			value: function goToSlide(overlay) {
				var _this2 = this;
	
				if (this.$zoomGallery.hasClass('slick-initialized')) {
					var openAtIndex = this.options.sliderSyncing ? this._$sourceGallery.slick('slickCurrentSlide') : this.triggerTargetIndex;
	
					$(overlay).imagesLoaded(function () {
						_this2.$zoomGallery.slick('slickGoTo', openAtIndex, true);
					});
				}
			}
		}, {
			key: 'renderModal',
			value: function renderModal(content) {
				var scope = this;
	
				this.modal = new _module2.default({
					modalID: scope.options.modalID,
					overlayClass: 'fullscreen',
					modalClass: scope.options.modalclass,
					modalContent: content,
					afterCreateCallback: function afterCreateCallback(overlay) {
						scope.$zoomGallery = $(overlay.querySelector('.' + scope._zGalleryClass));
	
						//This is required to trigger slick's goto properly
						scope.$zoomGallery.on('init', scope.goToSlide.bind(scope, overlay));
	
						_born2.default.carousel.init();
					},
					afterOpenCallback: this.goToSlide.bind(this),
					afterCloseCallback: function afterCloseCallback(overlay) {
						//Use Carousel methods to pause videos on the modal
						[].forEach.call(_module4.default.getPreviousVideos(scope.$zoomGallery[0]), _module4.default.pausePrevious);
	
						if (scope.options.sliderSyncing) {
							scope._$sourceGallery.slick('slickGoTo', scope.$zoomGallery.slick('slickCurrentSlide'), true);
						}
					}
				});
			}
		}]);
	
		return GalleryZoom;
	}();
	
	exports.default = GalleryZoom;

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _storelocator = __webpack_require__(45);
	
	var tooltip = __webpack_require__(47); // var locator = require('./storelocator');
	
	var $main = $('#main');
	var userPastOverlayScrollPos = [0, 0];
	function onStoreAvailabilityGAEvent() {
	    var product = dataLayer.find(function (o) {
	        return o.product != null;
	    }).product;
	    var user = dataLayer.find(function (o) {
	        return o.user != null;
	    }).user;
	    dataLayer.push({
	        'event': 'custom_event',
	        'eventCategory': 'PDP',
	        'eventAction': 'check_in_store_availability',
	        'eventLabel': 'check in store availability click',
	        'productName': product ? product.name : '', // Name of product page
	        'country': window.GlobalAttributes.COUNTRY,
	        'language': window.GlobalAttributes.LANGUAGE,
	        'screenName': 'PDP',
	        'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
	        'userId': user.user_id != '' ? user.user_id : ''
	    });
	}
	
	function initializeStoreEvents() {
	    //Open Checkinstore  Modal
	    $(document).on("click", ".chkstore--head", function () {
	        onStoreAvailabilityGAEvent();
	        $(".chkstore_container").addClass('toggle--active').find('.in').removeClass('in');
	        scrollLock(true);
	        if (typeof zE !== 'undefined' && !!zE) {
	            zE(function () {
	                zE.hide();
	            });
	        }
	        (0, _storelocator.resetStoreSearch)();
	        if (typeof pdpStoreStockCheckPushEvent !== "undefined") {
	            pdpStoreStockCheckPushEvent('store_availability_click');
	        }
	        $(".chkstore_size_container").removeClass('in');
	        $(".chkstore_store_container").addClass('in');
	
	        (0, _storelocator.resetStoreSearch)();
	        (0, _storelocator.initPDPStoreData)();
	        tooltip.init();
	    });
	
	    //Close Checkinstore Modal
	    $(document).on("click", ".chkstore_modal_close", function () {
	        $(".chkstore_container").removeClass('toggle--active');
	        $(".chkstore_size_container .swatch__link").removeClass('selected');
	        $(".checksize--instore").attr("disabled", "disabled");
	        scrollLock(false);
	        if (typeof zE !== 'undefined' && !!zE) {
	            zE(function () {
	                zE.show();
	            });
	        }
	    });
	
	    //Size Selection Highlights
	    $(".chkstore_size_container .swatches__item-size a").off().on("click", function (e) {
	        e.stopPropagation();
	        var target = $(this).parent('.swatch__link');
	        target.toggleClass('selected');
	        $(".chkstore_size_container .swatch__link.selected").length > 0 ? $(".checksize--instore").removeAttr("disabled") : $(".checksize--instore").attr("disabled", "disabled");
	    });
	
	    //Get Selected Size
	    $(document).on('click', ".checksize--instore", function () {
	        var selectedSize = [];
	        var targetEle = $(".chkstore_size_container .swatch__link.selected a.swatch__link--anchor");
	        targetEle.each(function () {
	            selectedSize.push($(this).attr('data-id'));
	        });
	        $(".chkstore_size_container").removeClass('in');
	        $(".chkstore_store_container").addClass('in');
	        var selected = selectedSize.join(" , ");
	        $(".selectedInfo").text(selected).data('selected', selected);
	        (0, _storelocator.resetStoreSearch)();
	        if (typeof pdpStoreStockCheckPushEvent !== "undefined") {
	            pdpStoreStockCheckPushEvent('size_store_selection');
	        }
	        (0, _storelocator.initPDPStoreData)();
	    });
	
	    //Back to CheckSize UI
	    $(document).on("click", ".backtosizeinfo", function () {
	        $(".chkstore_size_container").addClass('in');
	        $(".chkstore_store_container").removeClass('in');
	    });
	    $(document).ready(function () {
	        if ($('.chkstore_wrapper').length > 0) {
	            (0, _storelocator.initializePDPEvents)();
	        }
	    });
	}
	function scrollLock(state) {
	    if (state === true) {
	        userPastOverlayScrollPos = [self.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft, self.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop];
	        $('html').addClass('cancel-scroll noscrollios');
	        $('body').addClass('cancel-scroll');
	    } else {
	        $('html').removeClass('cancel-scroll noscrollios');
	        $('body').removeClass('cancel-scroll');
	        window.scrollTo(userPastOverlayScrollPos[0], userPastOverlayScrollPos[1]);
	    }
	}
	
	exports.initstore = function () {
	    initializeStoreEvents();
	};

/***/ })

});


// WEBPACK FOOTER //
// pdp.min.js